import { SourceDto, VideoDto } from './video.dto';

export class Video {
    id: string;
    placeholder: string;
    sources: Source[];

    constructor(data: VideoDto) {
        this.id = data.id ?? '';
        this.placeholder = data.url ?? '';
        this.sources = data.sources.map((source) => new Source(source));
    }
}

export class Source {
    src: string;
    type: 'video/mp4';
    constructor(data: SourceDto) {
        this.src = data.url ?? '';
        this.type = data.type ?? 'video/mp4';
    }
}
